<template>
  <base-section
  id="venue"
  >
    <v-container>
    <base-section-heading
    title="Conference venue"
    color="secondary"
    align="left"
    :toColor="true"
    >

    This year, IEEE Latin American Test Symposium (LATS2025) will take place in the <a href="https://www.hotelcasablancasanandres.com/" target="_blank"><strong>Casa Blanca Hotel</strong></a> in the <strong>Island of San Andres, Colombia</strong>. <br /> <br />

    <v-btn
      href="https://www.hotelcasablancasanandres.com/"
      target="_blank"
      rounded
      color="primary"
      dark
      style="padding: 15px"
      class="nowrap"
    >
      <v-icon
        left
        dark
      >
        mdi-open-in-new
      </v-icon>
      Visit the Conference Hotel website
    </v-btn>
<br><br>

The hotel Casablanca is placed in the San Andres Island very near to the beach, and it is surrounded by a large number of other hotel options having a broad price range. You can find the location <a href="https://maps.app.goo.gl/1rBo87F3xrMmU2Hi8" target="_blank">here</a>. <strong>Alternative options</strong> for reservations are also available at <router-link to="/venue/alternative-hotels"><strong>Alternative Hotels page</strong></router-link>. <br>

<br><br>
<div
class="d-flex justify-center"
>
<iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d70681.62274543638!2d-81.74608572127428!3d12.547954214369764!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f05af55eb2e2b9f%3A0x5cbb12dab6d00e6e!2sHotel%20Casablanca!5e0!3m2!1sit!2sit!4v1736846048398!5m2!1sit!2sit"
    width="80%"
    height="400"
    style="border:0;"
    allowfullscreen=""
    loading="lazy"
    referrerpolicy="no-referrer-when-downgrade"
    ></iframe>
</div>
<br>
<div
class="d-flex justify-center"
width="80%"
>
    <v-carousel
      cycle
      hide-delimiter-background
      show-arrows-on-hover
    >
      <v-carousel-item
        v-for="(slide, i) in slides"
        :key="i"
        :src="slide.src"
      >

      </v-carousel-item>
    </v-carousel>
    </div>
    </base-section-heading>
    <base-section-heading
    title="Booking procedure Conference Hotel"
    color="secondary"
    align="left"
    :toColor="true"
    >

    The costs of the hotel Casablanca for the conference are the following:<br><br>

- Standard Single Room (1 person):  COP $750.000 per night<br>
- Standard Double Room (2 persons): COP $845.000 per night<br>

<br>
<strong>In order to obtain the LATS2025 price, please book your hotel via email as follows:</strong><br>

<strong> - Email subject</strong>: LATS2025 room reservation<br>

<strong> - To</strong>: Johana Henriquez<br>

<strong> - Email address</strong>: reservas@hotelcasablancasanandres.com<br><br>

Please, while booking <strong>include the following email in c.c. : lats2025@gmail.com</strong><br>

In this way, we may support you during the reservation process.

<br><br>

Please check <strong>alternative options</strong> for reservations at <router-link to="/venue/alternative-hotels"><strong>Alternative Hotels page</strong></router-link>. <br>

    </base-section-heading>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'ConferenceHotel',

    data: () => ({
      slides: [
        {
          src: require('@/images/venue/casablanca (1).jpg'),
        },
        {
          src: require('@/images/venue/casablanca (2).jpg'),
        },
        {
          src: require('@/images/venue/casablanca (3).jpg'),
        },
        {
          src: require('@/images/venue/casablanca (4).jpg'),
        },
        {
          src: require('@/images/venue/casablanca (5).jpg'),
        },
        {
          src: require('@/images/venue/casablanca (6).jpg'),
        },
      ],
    }),
  }
</script>

<style>
.v-application .grey--text.text--darken-1 {
  color: black !important;
}
.nowrap .v-btn__content {
  width: 100%;
  white-space: break-spaces;
  text-align: center;
}
</style>
